import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

// Mobile counterpart of desktop's PlayerLink. Desktop PlayerLink reads
// `openPlayerModal` from PlayerModalContext; mobile pages own their own modal
// state (no PlayerModalProvider in MobileApp), so this variant takes the
// click handler as a prop. Visual treatment mirrors desktop (color +
// hover underline) so player names look hyperlinked anywhere on mobile.
const MobilePlayerLink = ({ mlbId, name, onClick, style = {} }) => {
  const isClickable = !!(mlbId && onClick);
  const handleClick = (e) => {
    if (!isClickable) return;
    e.stopPropagation();
    onClick(mlbId);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!isClickable}
      data-testid="mobile-player-link"
      style={{
        background: 'transparent',
        border: 'none',
        padding: 0,
        margin: 0,
        font: 'inherit',
        textAlign: 'left',
        color: dynastyTheme.tokens.colors.primary,
        cursor: isClickable ? 'pointer' : 'default',
        textDecoration: 'none',
        ...style,
      }}
      onMouseEnter={(e) => {
        if (isClickable) e.currentTarget.style.textDecoration = 'underline';
      }}
      onMouseLeave={(e) => {
        if (isClickable) e.currentTarget.style.textDecoration = 'none';
      }}
    >
      {name}
    </button>
  );
};

export default MobilePlayerLink;
